import api from "../utils/axiosInstance.js";
import { GET_LOGIN, GET_LOGIN_ERROR, GET_LOGIN_REQUEST, REMOVE_LOGED_STATUS, REMOVE_LOGIN, REMOVE_LOGIN_STATUS, UPDATE_AUTH_STATUS, UPDATE_OTP_TIME } from "../ActionTypes/ActionTypes.js";

const getLoginRequest = () => ({ type: GET_LOGIN_REQUEST });
const getLoginSuccess = (data) => ({ type: GET_LOGIN, payload: data });
const getLoginError = (error) => ({ type: GET_LOGIN_ERROR, payload: error });

export const UserLogin = (data) => async (dispatch) => {
  dispatch(getLoginRequest());
  try {
    const response = await api.post(`/login`, data);
    if (response?.data?.success) {      
      dispatch(getLoginSuccess(response.data));

      if (response.data.result?.sid) {
        localStorage.setItem("sid", response.data.result.sid);
      }

      if (response.data.result?.accessToken) {
        localStorage.setItem("token", response.data.result.accessToken);
      }

      // You can also save user details if needed
      if (response.data.result?.details) {
        localStorage.setItem("userData", JSON.stringify(response.data.result.details));
      }

    } else {
      dispatch(getLoginError(response?.data || "Somthing went wrong"));
    }
  } catch (error) {
    dispatch(getLoginError(error?.response?.data?.message || error?.message || "Somthing went wrong"));
  }
};

export const userLogout = (newData) => ({
  type: REMOVE_LOGIN,
  payload: newData,
});

export const removeLoginStatus = (newData) => ({
  type: REMOVE_LOGIN_STATUS,
  payload: newData,
})

export const updateOtpTime = (newData) => ({
  type: UPDATE_OTP_TIME,
  payload: newData,
})

export const updateAuthStatus = (newData) => ({
  type: UPDATE_AUTH_STATUS,
  payload: newData,
})

export const removeLogedStatus = (newData) => ({
  type: REMOVE_LOGED_STATUS,
  payload: newData,
});

export const logoutUserApi = (sid) => async (dispatch) => {
  try {
    const response = await api.post("/logout", { sid });
    return response.data;  // Return response data so caller can use it
  } catch (err) {
    console.error("Logout API failed", err);
    return { success: false, message: "Logout failed" };
  }
};
